import moment from "moment";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useTranslation } from "react-i18next";

const PackageBar: FC<Props> = ({
  id,
  date,
  expirationDate,
  totalDays = 14,
  expired = false,
}) => {
  const { t } = useTranslation();
  const deadline = expirationDate ?? moment(date).add(totalDays, "day");

  const actualDate = moment.utc();

  const days = moment(deadline).diff(actualDate, "day", true);
  const isOut = days <= 0 || expired;

  let percent = (days / 14) * 100;

  if (percent > 100) {
    percent = 100;
  }

  if (percent < 0) {
    percent = 0;
  }

  const text = isOut
    ? t("packageBar.expired")
    : t("packageBar.receiveByCountdown", {
        date: moment(expirationDate).format("DD.MM.yyyy"),
        count: Math.round(days),
      });

  return (
    <div
      data-tooltip-id={`bar-${id}`}
      data-tooltip-content={text}
      className={`${styles.br} ${styles.hover}`}
    >
      <div
        data-tooltip-id={`bar-${id}`}
        data-tooltip-content={text}
        className={styles.wrapper}
      >
        <div className={styles.bar}>
          <div
            style={{
              width: `${isOut ? 100 : percent}%`,
            }}
            className={`${styles.color} ${isOut && styles.old}`}
          ></div>
        </div>
        {!isOut && (
          <div
            style={{
              left: `${percent}%`,
            }}
            className={styles.dot}
          ></div>
        )}
      </div>
      <Tooltip
        place="bottom"
        style={{
          background: isOut ? "#BA1A1A" : "#5d49c7",
        }}
        id={`bar-${id}`}
      />
    </div>
  );
};

export default PackageBar;
